export const ORDER_STATUS_EXT_IDS = {
    PENDING: 0,
    NOT_CONFORMED: 5
}